// deno-fmt-ignore-file
export class MutateError extends Error {
    constructor(message) {
        super(message);
    }
}
